import { defineComponent as _defineComponent } from 'vue'
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'
import { uniqueId } from 'lodash'
import { computed } from 'vue'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchOnOff',
  props: {
  icon: null,
  disabled: { type: Boolean },
  prevent: { type: Boolean, default: false },
  inverted: { type: Boolean },
  value: { type: Boolean }
},
  emits: ["change", "input"],
  setup(__props, { emit }) {

const props = __props;



const id = uniqueId('switch-')

const { modelValue } = __MACROS_useVModel(["modelValue", "value", "input"])

const computedModelValue = computed({
  get() {
    return props.inverted ? !modelValue.value : modelValue.value
  },
  set(val) {
    modelValue.value = props.inverted ? !val : val
  },
})

watch(
  () => modelValue.value,
  (val) => {
    if (val && props.prevent) {
      modelValue.value = false
    }
  },
)



return { __sfc: true,props, id, modelValue, computedModelValue, emit, AppIcon }
}

})